import { Link, useSearchParams } from 'react-router-dom';
import styles from './Payment.module.scss';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderNo');

  return (
    <div className={styles.page}>
      <section className={styles.card}>
        <span className={`${styles.badge} ${styles.badgeSuccess}`} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </span>
        <span className={styles.eyebrow}>Order Complete</span>
        <h1 className={styles.title}>결제가 완료되었습니다</h1>
        {orderId && (
          <p className={styles.orderNo}>
            주문번호<strong>{orderId}</strong>
          </p>
        )}
        <p className={styles.desc}>[주문조회] 메뉴에서 진행 상황을 확인하실 수 있습니다.</p>
        <Link to="/lookup" className={styles.cta}>
          주문조회 바로가기
        </Link>
      </section>
    </div>
  );
}

export default PaymentSuccess;
